import { createMarketsApi } from "@/v2/api/metadata/markets";
import { createOutcomesApi } from "@/v2/api/metadata/outcomes";
import { createSportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createDialogs } from "./dialogs";
import { createFilters } from "./filters";

const LS_MARKETS_FILTERS_KEY = Symbol("markets-filters");

export function createMarketsView(ctx: BackofficeContext): EntityView {
  const marketsApi = createMarketsApi(ctx);
  const sportsApi = createSportsApi(ctx);
  const outcomesApi = createOutcomesApi(ctx);

  return {
    id: "markets",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx, sportsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, marketsApi, sportsApi, outcomesApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_MARKETS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: marketsApi.grid,
      },
    ],
  };
}
